"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGuid = getGuid;
exports.getKey = getKey;

function getGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

function getKey() {
  return "key-".concat(new Date().valueOf(), "-").concat(Math.ceil(Math.random() * 99999999));
}


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/KeyGen/index.js